import * as Types from '../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type AvailableReplacementCatalogueQueryVariables = Types.Exact<{
  productSlug: Types.Scalars['String'];
  model: Types.Scalars['String'];
}>;


export type AvailableReplacementCatalogueQuery = { __typename?: 'query_root', replacementCatalogue?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalogEntityResponse', data?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalogEntity', attributes?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalog', catalogId: string, entries?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'ComponentEntriesSmartphoneEntry', id: string, entryName: string, isNew?: Types.Maybe<boolean>, formerUpfrontPriceInCentsInclundingTax?: Types.Maybe<number>, blackFridayFormerUpfrontPriceInCentsInclundingTax?: Types.Maybe<number>, flagship?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneSubscription', smartphoneVariant?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneVariant', slug: string, storage?: Types.Maybe<string>, colorName?: Types.Maybe<string>, combinedPicture?: Types.Maybe<{ __typename?: 'UploadFileEntityResponse', data?: Types.Maybe<{ __typename?: 'UploadFileEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'UploadFile', alternativeText?: Types.Maybe<string>, formats?: Types.Maybe<any> }> }> }>, smartphoneFamily?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneFamily', slug: string, brand?: Types.Maybe<string> }> }> }> }> }> }> }> }> }>, subscriptionDrop?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'ComponentEntriesSubscriptionDrop', formerSubscriptionPriceInCentsIncludingTax?: Types.Maybe<number> }>>>, subscriptions?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionRelationResponseCollection', data: Array<{ __typename?: 'SmartphoneSubscriptionEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneSubscription', subscriptionItem?: Types.Maybe<{ __typename?: 'items', id: number, properties?: Types.Maybe<any>, priceExcludingTax?: Types.Maybe<number>, tax?: Types.Maybe<{ __typename?: 'taxes', id: number, amount: any }>, stock?: Types.Maybe<{ __typename?: 'devices_stock_view_cache', isOnline?: Types.Maybe<boolean> }> }>, smartphoneVariant?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneVariant', slug: string, storage?: Types.Maybe<string>, colorName?: Types.Maybe<string>, colorCode?: Types.Maybe<string> }> }> }> }> }> }>, tags?: Types.Maybe<{ __typename?: 'TagRelationResponseCollection', data: Array<{ __typename?: 'TagEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'Tag', name: string, slug: string }> }> }> }>>> }> }> }>, upfronts: Array<{ __typename?: 'items', id: number, properties?: Types.Maybe<any>, priceExcludingTax?: Types.Maybe<number>, tax?: Types.Maybe<{ __typename?: 'taxes', id: number, amount: any }> }> };


export const AvailableReplacementCatalogueDocument = gql`
    query availableReplacementCatalogue($productSlug: String!, $model: String!) {
  replacementCatalogue: b2CSmartphoneCatalog {
    data {
      attributes {
        catalogId
        entries(
          filters: {category: {eq: "available"}, subscriptions: {smartphoneVariant: {smartphoneFamily: {slug: {eq: $productSlug}}}}}
        ) {
          id
          entryName
          isNew
          formerUpfrontPriceInCentsInclundingTax
          blackFridayFormerUpfrontPriceInCentsInclundingTax
          flagship {
            data {
              id
              attributes {
                smartphoneVariant {
                  data {
                    id
                    attributes {
                      slug
                      storage
                      colorName
                      combinedPicture {
                        data {
                          id
                          attributes {
                            alternativeText
                            formats
                          }
                        }
                      }
                      smartphoneFamily {
                        data {
                          id
                          attributes {
                            slug
                            brand
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          subscriptionDrop {
            formerSubscriptionPriceInCentsIncludingTax
          }
          subscriptions {
            data {
              id
              attributes {
                subscriptionItem {
                  id
                  properties
                  priceExcludingTax: sell_price_in_cents_excl_tax
                  tax {
                    id
                    amount
                  }
                  stock {
                    isOnline: is_online
                  }
                }
                smartphoneVariant {
                  data {
                    id
                    attributes {
                      slug
                      storage
                      colorName
                      colorCode
                    }
                  }
                }
              }
            }
          }
          tags {
            data {
              id
              attributes {
                name
                slug
              }
            }
          }
        }
      }
    }
  }
  upfronts: items(
    where: {item_type: {_eq: "Upfront"}, _not: {properties: {_contains: {private: true}}}, properties: {_contains: {model: $model}}}
  ) {
    id
    properties
    priceExcludingTax: sell_price_in_cents_excl_tax
    tax {
      id
      amount
    }
  }
}
    `;
export function useAvailableReplacementCatalogueQuery(baseOptions: Apollo.QueryHookOptions<AvailableReplacementCatalogueQuery, AvailableReplacementCatalogueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableReplacementCatalogueQuery, AvailableReplacementCatalogueQueryVariables>(AvailableReplacementCatalogueDocument, options);
      }
export function useAvailableReplacementCatalogueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableReplacementCatalogueQuery, AvailableReplacementCatalogueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableReplacementCatalogueQuery, AvailableReplacementCatalogueQueryVariables>(AvailableReplacementCatalogueDocument, options);
        }
export type AvailableReplacementCatalogueQueryHookResult = ReturnType<typeof useAvailableReplacementCatalogueQuery>;
export type AvailableReplacementCatalogueLazyQueryHookResult = ReturnType<typeof useAvailableReplacementCatalogueLazyQuery>;
export type AvailableReplacementCatalogueQueryResult = Apollo.QueryResult<AvailableReplacementCatalogueQuery, AvailableReplacementCatalogueQueryVariables>;